export const endorsementCreditRating = [
  {
    label: 'Location',
    value: 'EU rated',
  },
  {
    label: 'Endorsement',
    value: 'None',
  },
];
